export const SET_EVITE_EVENT = 'eviteEvent/set';
